module.exports = __webpack_public_path__ + "img/search-options.01b2121d.png";